import { render, staticRenderFns } from "./HorizontalPlanIcon.vue?vue&type=template&id=3589cbb8&scoped=true&"
import script from "./HorizontalPlanIcon.vue?vue&type=script&lang=js&"
export * from "./HorizontalPlanIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3589cbb8",
  null
  
)

export default component.exports